import api from 'core/api';

export const competitions = () => api.get('/competitions');
export const competition = (id) => api.get(`/competitions/${id}`);
export const create = (data) => api.post(`/competitions/`, data);
export const update = (data) => api.put(`/competitions/${data.id}`, data);

export const payment = (data) => api.post(`/payments/competition`, data);
export const cancel = (id) => api.delete(`/competitions/${id}`);
